import { Link } from 'react-router-dom';
import { formatDistance } from 'date-fns';
import { Loading } from '../../components/loading';
import { StateBadge } from '../../components/badge';
import { useJobs } from '../../state';
import { styles } from '../../constants';

const Preview = ({ job }) => {
  try {
    switch (job.name) {
      case 'visit':
        return job.args?.url;
      case 'crawl':
        return job.args?.pattern;
      case 'extract':
        return new URL(job.args?.urls[0]).host + ' ' + JSON.stringify(job.args?.template);
      case 'scrape':
        return job.args?.pattern + ' ' + JSON.stringify(job.args?.template);
    }
  } catch {
    return '...';
  }
  if (job.name == 'crawl') {
  }
};

export const JobsList = ({ limit }) => {
  const { loading, didInit, jobs } = useJobs({ limit, types: ['extract', 'crawl', 'scrape'] });

  const border = '1px solid #ccc';

  const nodes = (jobs || []).map((job) => (
    <div
      key={job.id}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        fontSize: 14,
        padding: 5,
        borderTop: border,
        overflow: 'hidden',
        width: '100%',
      }}
    >
      <div style={{ width: 20 }}>
        <StateBadge state={job.state} />
      </div>
      <div style={{ width: 100, fontFamily: 'monospace', fontSize: 12 }}>
        <Link to={`/jobs/${job.id}`}>{job.id}</Link>
      </div>
      <div style={{ width: 60 }}>{job.name}</div>
      <div style={{ width: 120 }}>{formatDistance(new Date(job.created_at), new Date(), { addSuffix: true })}</div>
      <div style={{ flex: 1, ...styles.textOverflowStyle }}>
        <Preview job={job} />
      </div>
    </div>
  ));

  let listNode;
  if (!loading) {
    if (nodes.length) {
      listNode = <div style={{ borderBottom: border }}>{nodes}</div>;
    } else {
      listNode = <div>No jobs found</div>;
    }
  }

  return (
    <div style={{ overflow: 'hidden' }}>
      {(!didInit || loading) && <Loading />}
      {didInit && listNode}
    </div>
  );
};
